import Skeleton from '@mui/material/Skeleton';

export const ChatContentLoader = () => {
  return (
    <Skeleton
      animation="wave"
      sx={{ width: '75%', height: 60, alignSelf: 'flex-start', flexShrink: 0, transform: 'unset' }}
    />
  );
};
